import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceStatusPipe } from './pipes/invoice-status.pipe';

@NgModule({
	declarations: [InvoiceStatusPipe],
	imports: [CommonModule],
	exports: [InvoiceStatusPipe],
})
export class StripeModule {}
